import { periverseTheme, navigationTokens } from '@peritasai/ui-shared';

type NavColorTokens = {
  text: string;
  activeText: string;
  activeBg: string;
  hoverBg: string;
  hoverText?: string;
  icon: string;
  activeIcon: string;
  hoverIcon?: string;
};

export const NAV_COLOR_TOKENS: Record<'desktop' | 'mobile', NavColorTokens> = {
  desktop: {
    text: navigationTokens.text,
    activeText: navigationTokens.textActive,
    activeBg: navigationTokens.activeIconBg,
    hoverBg: navigationTokens.hoverBg,
    hoverText: navigationTokens.textActive,
    icon: navigationTokens.text,
    activeIcon: navigationTokens.textActive,
    hoverIcon: navigationTokens.textActive,
  },
  mobile: {
    text: 'text.primary',
    activeText: '#ECEFF1',
    activeBg: periverseTheme.palette.primary.light,
    hoverBg: periverseTheme.palette.primary.light,
    hoverText: '#ECEFF1',
    icon: 'text.secondary',
    activeIcon: '#ECEFF1',
    hoverIcon: '#ECEFF1',
  },
};
